//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
//  -- Components ---------------------
import InitialLoading from 'components/InitialLoading';
import PodcastLayout from 'features/PodcastLayoutNew';
import {  get , has } from "lodash";
import queryString from 'query-string';
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { handleListClassActivities , handleListClassActivitiesForStudent } from 'store/classActivities/thunks';
import { handleListClassQuizzes  , handleListClassQuizzesForStudent} from 'store/classQuizzes/thunks';
import { handleGetBubbleByBook, handleListUserNotes } from 'store/notes/thunks';
// import { handleListChapterQuizzes } from 'store/quizzes/thunks';
import { handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { handleTipsBook } from 'store/tips/thunks';
// import { handleListClassUsers } from 'store/userClasses/thunks';
import { useAlertView } from "store/alert/selectors";
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import styled from 'styled-components';
//  -- Lib ----------------------------
import { useVideos } from "store/resources/selectors";
import { find } from 'lodash';
import { handleListInstructionByClass, handleListInstructionByUser } from "store/instructions/thunks";
import { useAnswerView, usePDFView, useStoryView } from "store/main_book_popup/selectors";
import { handleGetAllSlides } from "store/slides/thunk";
import { handleListStoryAiConfig } from "store/StoryAiCofig/thunks";
import { useFetchAllContent } from "components/hooks";
import { handleGetDistrictTeacher } from 'store/users/thunks';
import { useAllDistrictTeacher } from 'store/users/selectors';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import SentryWrap from 'components/Sentry';
import { redirectToHome } from 'utils/config/navigation';




//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CenterContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    min-height: 90vh;
    justify-content: center;
    width: 100%;
`;


//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const VideosContainer = ({
    currentClass,
    currentUser,
    tipsBook,
    quizzes,
    classUsers,
    classQuizzes,
    classActivities,
    interactions,
    submissions,
    activities,
    notes,
}) => {
 
    const location = useLocation();
  	const navigate = useNavigate();
    const dispatch = useDispatch();
    const allDistrictTeacher = useAllDistrictTeacher();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [loadingContent,setLoadingContent]=useState(true)
    const [mounted, setMounted] = useState(false);
    const [showAnswerFlag, setShowAnswerFlag] = useState(null);
    const [,invokeAlert,revokeALert ] =useAlertView()
    const orgPermissions = useCurrentOrgPermission()
    const { revokeAnswerView } = useAnswerView();
    const { revokePDFView } = usePDFView();
    const { revokeStoryView } = useStoryView();
    const search = useMemo(()=>queryString.parse(location.search),[location.search]) ;
    const videos = useVideos()
    const {fetchAllContent} = useFetchAllContent();

    useEffect(() => {
        setTimeout(() => setMounted(true), 250)
        return () => {
            revokeAnswerView();
            revokePDFView();
            revokeStoryView();
        }
    }, []);

    useEffect(() => {
        async function fetchData() {
            try {
                await getCurrentUser();
            } catch {
                navigate('/');
            }
        }
        fetchData();
    }, []);
    useEffect(()=>{
        if(orgPermissions && typeof orgPermissions['1WAYRESOURCES']==="boolean"){
          if(!orgPermissions['1WAYRESOURCES']){
            invokeAlert()
            setTimeout(()=>{
              navigate(redirectToHome(currentUser) || '-1');
              revokeALert()
            },4000)
          }
        }
      },[orgPermissions])
    useEffect(() => {
        const videoData = find(videos,['id',search.id])
        setData(videoData);
        
    }, [search.id,videos])
    const getBookQuestinAndQuiz = async () => {
        if (has(currentClass, "id") && get(currentUser, "role") != "student") {
            dispatch(handleListClassActivities(currentClass.id));
            dispatch(handleListClassQuizzes(currentClass.id));
          } else {
            dispatch(handleListClassActivitiesForStudent(get(currentClass, "id"), get(currentUser, "id")));
            dispatch(handleListClassQuizzesForStudent(get(currentClass, "id"), get(currentUser, "id")));
          }
      }
    const getStudentSubmissions =async () =>{
        if(currentUser?.role=="student"){
            // await dispatch(handleListUserSubmissions(currentUser?.id))
            return  dispatch(handleListUserSubmissionsByClass(currentUser?.id,currentClass?.id))
         }
    }

    const fetchDistrictData = async () => {
      try {
        if (currentUser?.orgId && currentUser?.id && currentUser?.role === 'teacher' && allDistrictTeacher.length === 0) {
          dispatch(handleGetDistrictTeacher(currentUser?.orgId, currentUser?.id));
        }
      } catch (error) {
        console.log(error, 123);
      }
    };

    const fetchLearningModuleCount = async () => {
        if (currentUser?.role === 'student' || currentUser?.role === 'teacher') {   
          dispatch(handleLearningModuleCount({
            chapter: search.id,
            userId: currentUser?.role === 'student' ? currentClass?.teacherId : currentUser.id,
            pageId: search.id,
          }));
        }
    };

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            setLoadingContent(true)
            const videoScreenloaded =localStorage.getItem('videoScreenloaded')
            listInstruction();
            if(videoScreenloaded&&videoScreenloaded==currentClass.id){
                setLoadingContent(false)
            }
            // if(reourcesQuizzes.length==0){
            //      await dispatch(handleListChapterQuizzes(search.id))    
            // }
           const payloadForNotes = {
                chapter : search.id,
                classId: get(currentClass, "id"),
                userId: get(currentUser, "id")
           }
            const is_student = currentUser?.role === "student";
            const user_id = currentUser?.id;
            const class_id = currentClass?.id;
            await Promise.allSettled([
               
            getBookQuestinAndQuiz(),
            fetchDistrictData(),
            //dispatch(handleListUserNotes(currentUser?.id)),
            getStudentSubmissions(),
            dispatch(handleTipsBook(search.id)),
            dispatch(handleGetBubbleByBook(payloadForNotes)),
            fetchAllContent(search.id,search.id),
            dispatch(handleListStoryAiConfig({ chapter: search?.id, user_id, class_id }, is_student)),
            listSlidesItem(),
            fetchLearningModuleCount()
           ])
            setLoadingContent(false)
            localStorage.setItem('videoScreenloaded', currentClass?.id);
            setLoading(false);
        }
        fetchData();
    }, [currentUser?.id, currentClass?.id, dispatch])

    async function listSlidesItem(){
        await dispatch(handleGetAllSlides(search.id))
    }
    const listInstruction = async () => {
        if (has(currentUser, "id") && currentUser.role == "teacher") {
            await dispatch(handleListInstructionByUser(currentUser.id))
        }
        if (has(currentClass, "id") && currentUser.role != "teacher") {
            dispatch(handleListInstructionByClass(get(currentClass, "id")));
        }
    }

    return (
    <SentryWrap>
        {loading ? (
        <CenterContainer>
            <InitialLoading mounted={mounted} />
        </CenterContainer>
    ) : (
        <PodcastLayout 
            data={data} 
            id={search.id}
            quiz={search.quiz}
            activity={search.activity}
            loading={loading}
            showAnswerFlag={showAnswerFlag}
            setShowAnswerFlag={setShowAnswerFlag}
            tipsBook={tipsBook}
            quizzes={quizzes}
            classUsers={classUsers} 
            classQuizzes={classQuizzes}
            classActivities={classActivities}
            submissions={submissions}
            loadingContent={loadingContent}
            currentUser={currentUser}
            currentClass={currentClass}
            interactions={interactions}
            activities={activities}
            notes={notes}
        />
        )}
    </SentryWrap>
    );
};



//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    currentClass: state.currentClass,
    currentUser: state.currentUser,
    tipsBook: state.tipsBook,
    quizzes: state.quizzes,
    classUsers: state.classUsers,
    classQuizzes: state.classQuizzes,
    classActivities: state.classActivities,
    submissions: state.submissions,
    notes: state.notes,
    activities: state.activities,
    interactions: state.interactions,
});

export default connect(mapStateToProps, null)(VideosContainer);
